<template>
    <div class="Page">
        <Header Act="1"></Header>
        <div class="MaxWid">
            <div class="MarTop">
                <Banner></Banner>
            </div>
            <div class="IndexNav MarTop">
                <div class="IndexNavItem BgColorBlue" @click="GoPage('/RegQuery')">寻求心理服务</div>
                <div class="IndexNavItem BgColorYellow" @click="GoPage('/ApplyReg?id=2')">专业机构注册</div>
                <div class="IndexNavItem BgColorGreen" @click="GoPage('/ApplyReg?id=1')">专业人员注册</div>
            </div>
            <div class="IndexInfo MarTop">
                <div class="IndexInfoItem">
                    <div class="IndexInfoTit">
                        <span>公告栏</span>
                        <span class="IndexInfoMore" @click="GoPage('/NoticeList')">更多<i class="el-icon-d-arrow-right"></i></span>
                    </div>
                    <div class="IndexInfoCont">
                        <div class="IndexInfoContItem" v-if="index<3" v-for="(item,index) in XiangMuData" :key="item.id">
                            <div class="IndexInfoContDis">
                                <i class="el-icon-caret-right"></i>
                                <div class="IndexInfoContTxt Text2"  @click="GoDetail(item,5)">{{item.title}}</div>
                            </div>
                            <div class="IndexInfoContImg">
                                <img :src="$Global.CommImgHttp+item.img" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="IndexInfoItem BgColor">
                    <div class="IndexInfoTit">信息公示</div>
                    <div class="IndexInfoCont Border0">
                        <swiper class="swiper" :options="swiperOption" style="height: 180px;">
                            <swiper-slide v-for="item in InfoData" :key="item.id">
                                <div class="IndexInfoContItem">
                                    <div class="IndexInfoContDis">
                                        <div class="IndexInfoContTxt Text2" @click="GoDetail(item,6)">{{item.name}}</div>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>
            </div>
            <div class="IndexDynamic MarTop">
                <div class="IndexDynamicDis">
                    <div class="IndexDynamicTit">新闻动态</div>
                    <!-- <div class="IndexDynamicAll">更多<i class="el-icon-d-arrow-right"></i></div> -->
                </div>
                <div class="IndexDynamicCont">
                    <div class="IndexDynamicItem" v-for="item in XinWenData" :key="item.id">
                        <div class="IndexDynamicImg">
                            <img :src="$Global.CommImgHttp+item.img" alt="">
                        </div>
                        <div class="IndexDynamicFlex">
                            <div class="IndexDynamicItemTit Text1" @click="GoDetail(item,6)">{{item.title}}</div>
                            <div class="IndexDynamicItemTxt Text2" v-html="item.content"></div>
                            <div class="IndexDynamicItemTime">{{$Global.goTime(item.createtime)}}</div>
                        </div>
                    </div>
                </div>
                <!-- <div class="PageDis">
                    <el-pagination background :page-sizes="[10, 20, 50]" layout="prev,pager,next,total,sizes"  @size-change="SizeChange" @current-change="PageChange" :total="total" :current-page="page" :hide-on-single-page="false"></el-pagination>
                </div> -->
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/header/head';
    import Footer from '@/components/header/footer';
    import Banner from '@/components/banner/Banner';
    export default {
        components: {
            Header,
            Footer,
            Banner,
        },
        data() {
            return {
                XiangMuData:[],
                InfoData:[],
                XinWenData:[],
                total:0,
                page:1,
                SizePage:10,
            }
        },
        computed: {
            swiperOption() {
                // 当数据少于3条时，禁用loop模式，避免重复显示
                const enableLoop = this.InfoData.length > 3;
                return {
                    loop: enableLoop,
                    autoplay: {
                        delay: 1000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false,
                    },
                    direction: 'vertical',
                    slidesPerView: 3, 
                    allowTouchMove: true,
                };
            }
        },
        mounted() {
            this.GetXiangMu();
            this.GetInfo();
            this.GetXinWen();
        },
        methods: {
            GetXiangMu(){
                this.$post("api/index/noticeList")
                .then(res => {
                     if(res.data.code == 1){
                         this.XiangMuData = res.data.data.data
                     }
                })
            },
            GetInfo(){
                this.$post("api/index/registerList",{
                    limit:99,
                }).then(res => {
                     if(res.data.code == 1){
                         this.InfoData = res.data.data.data
                     }
                })
            },
            GetXinWen(){
                this.$get("api/index/newsList",{
                    page:this.page,
                    limit:this.SizePage,
                }).then(res => {
                     if(res.data.code == 1){
                         this.total = res.data.data.total;
                         this.XinWenData = res.data.data.data;
                     }else{
                         this.$message.error(res.data.msg)
                     }
                })
            },
            SizeChange(val) {
                this.SizePage = val;
                this.GetXinWen();
            },
            PageChange(val) {
                this.page = val;
                this.GetXinWen();
            },
            GoDetail(item,num) {
                localStorage.setItem("Info",JSON.stringify(item))
                localStorage.setItem("InfoState",num)
                this.$router.push({
                    path: '/InfoDetail',
                });
            },
            //跳转
            GoPage(url) {
                this.$router.push({
                    path: url
                });
            },
        },
    }
</script>
<style scoped>
    .Page {
        background: #fff;
    }

    .BgColorBlue {
        background-color: #037dbe;
    }

    .BgColorYellow {
        background-color: #ed8404;
    }

    .BgColorGreen {
        background-color: #82ae1d;
    }

    .MarTop {
        margin-top: 20px;
    }

    .MaxWid {
        max-width: 1180px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .IndexNav {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 1.4rem;
    }

    .IndexNavItem {
        flex: 1 0 250px;
        padding: 30px 0;
        text-align: center;
        color: #fff;
        font-size: 30px;
        font-weight: 700;
        border-radius: 10px;
        cursor: pointer;
    }

    .IndexInfo {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
    }
    
    .IndexInfoItem {
        width: 48%;
        flex: 1 1 25%;
        border: 1px solid #ddd;
        border-radius: 10px;
        padding: 10px;
        min-height: 240px;
    }
    .IndexInfoItem.BgColor{
        background: #E4EEF8;
    }
    .PageDis{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }
    @media only screen and (max-width: 550px) {
        .IndexInfoItem {
            flex: 1 1 100%;
        }
    }

    .IndexInfoTit {
        font-size: 20px;
        color: #235da7;
        font-weight: bold;
        padding-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .IndexInfoMore {
        font-size: 14px;
        color: #666;
        cursor: pointer;
        font-weight: normal;
    }

    .IndexInfoCont {
        border: 1px solid #ddd;
    }
    .IndexInfoCont.Border0{
        border: 0;
    }

    .IndexInfoContItem {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #ddd;
        cursor: pointer;
    }

    .IndexInfoContItem:last-child {
        border-bottom: none;
    }

    .IndexInfoContDis {
        display: flex;
        align-items: baseline;
        margin: 10px;
        flex: 1;
    }

    .IndexInfoContTxt {
        flex: 1;
        height: 40px;
        font-size: 14px;
        color: #333;
    }

    .IndexInfoContImg {
        border-left: 1px solid #ddd;
        width: 50px;
        padding: 5px;
    }

    .IndexDynamicDis {
        border-top: 2px solid #394788;
        border-left: 2px solid #394788;
        padding: 10px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .IndexDynamicTit {
        color: #235da7;
        font-size: 18px;
        font-weight: bold;
        background: #fff;
    }

    .IndexDynamicAll {
        cursor: pointer;
        font-size: 12px;
        color: #666;
        font-weight: 100;
    }

    .IndexDynamicCont {
        background: #fff;
    }

    .IndexDynamicItem {
        display: flex;
        align-items: center;
        padding: 20px;
    }

    .IndexDynamicItem:hover {
        background: #ddd;
        cursor: pointer;
    }

    .IndexDynamicImg {
        width: 100px;
        margin-right: 20px;
    }

    .IndexDynamicFlex {
        flex: 1;
        width: 1px;
    }

    .IndexDynamicItemTit {
        font-size: 16px;
        color: #235da7;
    }

    .IndexDynamicItemTxt {
        font-size: 14px;
        margin: 10px 0;
    }

    .IndexDynamicItemTime {
        color: #666;
        font-size: 12px;
    }
</style>